import * as React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
import styled from 'styled-components';
import { DocumentTitle } from '@helpcenter/document-title';
import { ThemedLink } from '@helpcenter/themed-link';
import { PaperContent } from 'view/layout/paper';
import Heading from '@atlaskit/heading/heading';
import { Text } from '@atlaskit/primitives/text';
import { token } from '@atlaskit/tokens';

export interface Props {
	title: string;
	icon?: React.ComponentClass | React.FunctionComponent;
	header?: string;
	description?: string;
	callToActionHref?: string;
	callToActionText?: string;
	dataTestId?: string;
	actionHrefTarget?: '_blank' | '_self' | '_parent' | '_top';
}

const SimpleIconPage = ({
	actionHrefTarget,
	title,
	header,
	description,
	callToActionHref,
	callToActionText,
	dataTestId,
	icon: Icon,
}: Props) => {
	return (
		<DocumentTitle title={title}>
			<PaperContent>
				<ContainerV2 data-testId={dataTestId}>
					{!!Icon && <Icon />}
					{!!header && (
						<Heading as="h1" size="medium">
							{header}
						</Heading>
					)}
					{!!description && <Text>{description}</Text>}
					{!!callToActionHref && (
						<LinkWithUnderline
							to={callToActionHref}
							actionSubjectId="callToAction"
							target={actionHrefTarget}
						>
							{callToActionText}
						</LinkWithUnderline>
					)}
				</ContainerV2>
			</PaperContent>
		</DocumentTitle>
	);
};

export default SimpleIconPage;

// eslint-disable-next-line rulesdir/no-styled-export, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const ContainerV2 = styled.div({
	display: 'flex',
	flexFlow: 'column wrap',
	alignItems: 'center',
	gap: token('space.100', '8px'),
	marginTop: token('space.600', '48px'),
});

// eslint-disable-next-line rulesdir/no-styled-export, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const LinkWithUnderline = styled(ThemedLink)`
	text-align: center;
	text-decoration: underline;
`;
